import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';

class CloseButton extends RenderContainer {
  constructor() {
    super();
    this.name = 'CloseButton';
    this.imageName = 'close-icon';
    this.bitmap = null;
    loader.addItem(this, this.imageName);
    this.relX = 0.05;
    this.relY = 0.07;
    const pos = globals.relToScreen({ x: this.relX, y: this.relY });
    this.x = pos.x;
    this.y = pos.y;
    this.maxWidth = 0.12;
    this.maxHeight = 0.12;
    const size = globals.relSizeToScreen({
      x: this.maxWidth,
      y: this.maxHeight
    });
    this.render.stream = false;
    this.width = size.x;
    this.height = size.y;
    this.setBounds(this.x, this.y, this.width, this.height);
    this.shadow = new createjs.Shadow('#aaaaaa', 0, 3, 4);
  }

  loaded() {
    const tag = loader.getItem(this.imageName);
    this.clipImageSizeToSize(tag);
    this.centerOnSelf();
    this.bitmap = new createjs.Bitmap(tag);
    this.addChild(this.bitmap);
  }
}

export { CloseButton as default };
